import React from "react";
import styled from "styled-components";
import SettingsView, { NoContextMenu } from "common/SettingsView";
import TextInput from "common/TextInput";
import { requestMoment } from "views/Status/Billing/api";

const Interactive = styled.div`
  margin: 1em;
  & > * {
    margin: 1em 0;
  }
  & .error,
  & .success {
    text-align: center;
    margin: 0.5em;
  }
  & .error {
    color: red;
  }
  input[type="file"] {
    display: none;
  }
`;

const DownloadSettings = ({ onChange }) => (
  <Interactive>
    <b>NOTE:</b> File will be stored in the default Downloads directory.
    <TextInput
      type="text"
      name="filename"
      label="File Name:"
      required={true}
      icon="folder"
      placeholder={"Desired file name"}
      className="input-control"
      defaultValue={""}
      onChange={onChange}
    />
    This backup includes only subscriber id's, subscriber-groups, and policies
    assigned or defined via Radius/REST/Billing systems.
    <br />For the rest of the system configuration, use the backups produced in
    "Save Configuration".
  </Interactive>
);

function SaveSubsAttributes(){
  const doRequestSave = (filename) => 
    ifCl.run(`api storage write file /tmp/${filename} force`)
  ;

  const apply = ({ filename }, _originalSettings = {}) => {
    const filePath = `/tmp/${filename}`;
    return doRequestSave(filename).then(
      () => ifCl.getFile(`/tmp/${filename}`, (res)=> {
        var resp = res.GetFileResponse;
        var thereIsError = false;

        if (resp.code != 0) {
          thereIsError = true;
          console.log('GetFile.error: %s %s', filePath, resp.reason);
          if(!silent){
            showModalError('Error:', 'Cannot find file: '+filePath);
          }
        } else {
          getFile.begin(resp.id, filePath);
        }
      })
    )
    .catch(error=>{
      throw error;
    });
  };
  const load = () => requestMoment();
  return (
    <SettingsView
      load={load}
      apply={apply}
      ContextMenu={NoContextMenu}
      title="Save Backup of External Attributes and Subscriber Groups"
      applyActionClassName="hidden-to-operators"
      noDiscard={true}
      PendingChangesIndicator={null}
      applyLabel="SAVE"
    >
      <DownloadSettings />
    </SettingsView>
  );
}

export default SaveSubsAttributes;
